import * as React from 'react';
import './error-message.scss';
import * as _ from 'lodash';
import { generateInnerHtml } from 'shared-react';
import { POSSIBLE_ERROR_MESSAGES } from 'login-utils/loginErrorMessageUtils';

const ErrorMessage = ({ errorText, errorId, ...htmlProps }: { errorText: string; errorId?: string }) => {
  // Only allow HTML for predefined error messages.
  if (!_.includes(POSSIBLE_ERROR_MESSAGES, errorText)) {
    errorText = _.escape(errorText);
  }

  const errorProp = errorId ? { id: errorId } : {};

  return (
    <span className="Error" {...errorProp} tabIndex={-1} {...htmlProps}>
      <span className="Error-text" {...generateInnerHtml(errorText)} />
    </span>
  );
};

export default ErrorMessage;
